module.exports = __webpack_public_path__ + "static/media/rings-logo.b2bb6437.png";